module.exports = __webpack_public_path__ + "static/media/malaikoftacurry.02f223a5.jpg";